// extracted by mini-css-extract-plugin
export var banner = "_c8-0";
export var closeButton = "_c8-2";
export var greenCheckmark = "_c8-3";
export var hereLink = "_c8-4";
export var titleIcon = "_c8-1";